import { useState } from 'react';
import { Button, ButtonGroup } from '@chakra-ui/react';

import { Modal, Select } from 'shared-components';

import { ITag } from 'types';
import { useTranslation } from "react-i18next";

export interface IProps {
  studentNo: string;
  university: string;
  intakeId: string;
  offerId: string;
  onClose: () => void;
  tags: ITag[];
  programmableTags: ITag[];
  pinTagsToStudents: ({
    tags,
    studentNumbers,
  }: {
    tags: { id: string; isProgrammable: boolean }[];
    studentNumbers: string[];
  }) => void;
}
enum ActionSelection {
  TAGS = 'TAGS',
  PROGRAMMABLE_TAGS = 'PROGRAMMABLE_TAGS',
}
const AddTagModal = (props: IProps) => {
    const { t } = useTranslation('common');
  const {
    tags = [],
    programmableTags = [],
    pinTagsToStudents,
    studentNo,
    university,
    intakeId,
    offerId,
    onClose,
  } = props;
  const p_key = `${university}#${studentNo}#${intakeId}#${offerId}`;

  const [selectedTag, setSelectedTag] = useState(undefined);

  const dropdownOptions = [
    {
      label: 'Tags',
      value: ActionSelection.TAGS,
      populate: {
        options: [
          ...tags.map(({ label, id: value }) => ({
            label,
            value,
          })),
        ],
      },
    },
    ...(programmableTags.length > 0
      ? [
          {
            label: 'Programmable Tags',
            value: ActionSelection.PROGRAMMABLE_TAGS,
            populate: {
              options: programmableTags.map(({ label, id: value }) => ({
                label,
                value,
              })),
            },
          },
        ]
      : []),
  ];

  const submit = () => {
    const isProgrammableTag = !!programmableTags.find(tag => tag.id === selectedTag);

    pinTagsToStudents({ tags: [{ id: selectedTag!, isProgrammable: isProgrammableTag }], studentNumbers: [p_key] });
    onClose();
  };

  return (
    <Modal
      id="edit-visa-status"
      show={true}
      title={t('common:addTag2')}
      onClose={onClose}
      footer={
        <ButtonGroup size={'lg'} spacing={3}>
          <Button id="back-button" onClick={() => props.onClose()} data-selector="add-tag-back-button">
            Back
          </Button>

          <Button
            id="submit-status-button"
            onClick={submit}
            isDisabled={!selectedTag}
            variant={'solid'}
            data-selector="add-tag-submit-button"
          >
            Add tag
          </Button>
        </ButtonGroup>
      }
    >
      <Select
        id={'selectedTag'}
        label={t('common:selectTag')}
        options={dropdownOptions}
        value={selectedTag}
        placeHolder={t('common:select')}
        onChange={(evt: any) => {
          setSelectedTag(evt.target.value);
        }}
      />
    </Modal>
  );
};

export default AddTagModal;
